import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
 const Cartridge = (props) => (
   <SvgIcon {...props}>
    <g>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M15.3,1v21.267C15.3,22.67,13.822,23,12,23s-3.3-0.33-3.3-0.733V1H15.3z"/>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M8.7,10.533c0,0.405,1.477,0.733,3.3,0.733s3.3-0.328,3.3-0.733"/>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M8.7,19.333c0,0.405,1.477,0.733,3.3,0.733s3.3-0.328,3.3-0.733"/>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M13.467,16.4c0-0.81-1.467-2.933-1.467-2.933s-1.467,2.123-1.467,2.933c0,0.81,0.657,1.467,1.467,1.467S13.467,17.21,13.467,16.4z"
        />
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M8.7,5.4c0,1.823,1.477,3.3,3.3,3.3s3.3-1.477,3.3-3.3"/>
    </g>
   </SvgIcon>
);

export default Cartridge;



// WEBPACK FOOTER //
// ./src/icons/types/Cartridge.jsx